/**
 * @return {undefined | Object}
 */
module.exports = function getReturningUserData() {
    let returningUser = localStorage.getItem("returningUserStore");
    if (returningUser) {
        return JSON.parse(returningUser);
    }
}